import { api } from './api'
import { Position } from '../types'

export const positionService = {
  async getAll(includeInactive = false): Promise<Position[]> {
    const params = includeInactive ? { includeInactive: 'true' } : {}
    const response = await api.get('/configuration/positions', { params })
    return response.data.data || response.data
  },

  async getActive(): Promise<Position[]> {
    // Usar getAll y filtrar solo los activos
    const response = await api.get('/configuration/positions')
    const data = response.data.data || response.data
    return Array.isArray(data) ? data.filter((p: Position) => p.isActive) : []
  },

  async getById(id: string): Promise<Position> {
    const response = await api.get(`/configuration/positions/${id}`)
    return response.data.data || response.data
  },

  async create(data: { name: string; isActive?: boolean }): Promise<Position> {
    const response = await api.post('/configuration/positions', data)
    return response.data.data || response.data
  },

  async update(id: string, data: { name?: string; isActive?: boolean }): Promise<Position> {
    const response = await api.put(`/configuration/positions/${id}`, data)
    return response.data.data || response.data
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/configuration/positions/${id}`)
  },
}
